import {HTMLAttributes} from 'react';
import {MessageThreadSummary, MessageThread} from '@/api/dto/message';
import {Wrapper, Sentence} from '@/components/pages/messages/MessageThreadTitle.styles';

export type Truncate = boolean | 'unstable';

type Props = HTMLAttributes<HTMLSpanElement> & {
  messageThread?: MessageThreadSummary | MessageThread;
  about?: string;
  truncate?: Truncate;
  simple?: boolean;
}

export default function MessageThreadTitle({ messageThread, about, truncate, simple, ...props }: Props) {
  const name = about || (messageThread && 'about' in messageThread && messageThread.about);

  return (
    <Wrapper truncate={truncate} simple={simple} {...props}>
      <Sentence truncate={truncate}>
        {messageThread
          ? messageThread.subject || 'Message'
          : 'New message'}
      </Sentence>
      {name && (
        <Sentence truncate={truncate}> about {name}</Sentence>
      )}
    </Wrapper>
  );
}
